import { useRouteError, Link, useNavigate } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { Typography } from "@/components/ui/Typography";

const FRIENDLY_MESSAGE =
  "We ran into a problem loading this page. Try again later.";

/**
 * App-level error fallback used as the root route's errorElement.
 * Renders when any descendant route throws (e.g. on refresh in analytics).
 * Shows a UX-friendly message; the actual error is consumed for boundary handling only.
 */
export function ErrorBoundary() {
  useRouteError(); // consume error so React Router is satisfied
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 dark:bg-slate-900 px-4">
      <div className="text-center max-w-md">
        <LogoMark size={48} className="mx-auto mb-4" />
        <Typography variant="h1" className="mb-2">
          Something went wrong
        </Typography>
        <p className="text-slate-500 dark:text-slate-400 text-center mb-8 leading-relaxed">
          {FRIENDLY_MESSAGE}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => navigate(0)}
            className="w-full sm:w-auto rounded-xl bg-primary-600 px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-primary-600/20 hover:bg-primary-700 active:scale-[0.98] transition-all"
          >
            Try again
          </button>
          <Link
            to="/"
            className="w-full sm:w-auto rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 px-6 py-3 text-sm font-semibold text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 active:scale-[0.98] transition-all text-center"
          >
            Go to home
          </Link>
        </div>
      </div>
    </div>
  );
}
